import SyncCustomFieldOptions from "../../constants/SyncCustomFieldOptions";
import { SYNC_NARRATIVE_FOLDER_IDENTIFIER } from "../../constants/syncNarrativeFolderIdentifier";
import syncSettingsSelectors from "../../modules/sync/settings/selectors";
import { mapPick } from "../../utils/immutableExtensions";
import createNewTreeFromSubtreeIds from "../../utils/tree/createNewTreeFromSubtreeIds";
import getIdsInTree from "../../utils/tree/getIdsInTree";
import replaceIdInTree from "../../utils/tree/replaceIdInTree";

const getAllowedPropertyIds = settings => {
  return settings.fields
    .map(sf =>
      sf.customFieldId && sf.customFieldId !== SyncCustomFieldOptions.ULYSSES_NOTE
        ? sf.customFieldId
        : sf.customFieldName
          ? sf.customFieldName
          : null
    )
    .filter(sf => sf)
    .toList()
    .push("title")
    .toSet()
    .toList();
};

export default (rep, syncSettings, retainAllDocuments = false) => {
  if (!rep) {
    return rep;
  }

  // Grab a copy of rep which we will update as we go
  let syncableRep = rep;

  // First, work out if we need to rename the narrative folder to our internal identifier
  if (
    syncableRep.documents.has(syncSettings.narrativeFolderId) &&
    !syncableRep.documents.has(SYNC_NARRATIVE_FOLDER_IDENTIFIER)
  ) {
    let narrativeRootDoc = syncableRep.documents.get(syncSettings.narrativeFolderId);
    if (narrativeRootDoc) {
      narrativeRootDoc = narrativeRootDoc.set("id", SYNC_NARRATIVE_FOLDER_IDENTIFIER);
    }
    syncableRep = syncableRep
      .update("documentTree", tree =>
        replaceIdInTree(tree, syncSettings.narrativeFolderId, SYNC_NARRATIVE_FOLDER_IDENTIFIER)
      )
      .update("documents", documents =>
        documents.set(SYNC_NARRATIVE_FOLDER_IDENTIFIER, narrativeRootDoc).delete(syncSettings.narrativeFolderId)
      );
  }

  // Work out which folders we need to keep for syncing comparison
  const folderIds = syncSettingsSelectors.getSyncRootFolderIdsFromSettings(syncSettings);
  // And extract them out into a new tree, promoting everything to the root
  syncableRep = syncableRep.set("documentTree", createNewTreeFromSubtreeIds(syncableRep.documentTree, folderIds));

  const ids = getIdsInTree(syncableRep.documentTree);
  if (!retainAllDocuments) {
    syncableRep = syncableRep.update("documents", documents => mapPick(documents, ids));
  }

  const allowedPropertyIds = getAllowedPropertyIds(syncSettings);

  // Remove any properties that are not part of syncing
  syncableRep = syncableRep.update("documents", documents => {
    return documents.map(doc => {
      return doc.update("properties", properties => mapPick(properties, allowedPropertyIds));
    });
  });

  // Also trim any custom fields that are no longer syncable (i.e. settings turned them off)
  syncableRep = syncableRep
    .update("customFields", customFields =>
      customFields.filter(f => Boolean(syncSettings.fields.find(sf => sf.customFieldId === f.id)))
    )
    .update("customFieldsOrder", customFieldsOrder =>
      customFieldsOrder.filter(f => Boolean(syncSettings.fields.find(sf => sf.customFieldId === f.id)))
    );

  return syncableRep;
};
